module.exports = import("https://unpkg.com/@web3modal/html@2.6.2");;